import { render, staticRenderFns } from "./QuickCall.vue?vue&type=template&id=05f6e84c&scoped=true&"
import script from "./QuickCall.vue?vue&type=script&lang=ts&"
export * from "./QuickCall.vue?vue&type=script&lang=ts&"
import style0 from "./QuickCall.vue?vue&type=style&index=0&id=05f6e84c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f6e84c",
  null
  
)

export default component.exports